<div class="homeSideBar">
    <div class="homeLoginArea" *ngIf="obChangeEmail.type==='email' && obChangeEmail.refNo == ''">
        <span class="homeSideBarHeader" [innerHTML]="'ACCOUNT_CHANGEEMAIL_EMAIL_TITLE' | translate"></span>
        <div class="departureTimeListArea">
            <div class="tab-pane">
                <div class="formPagesContent">
                    <!--span class="editItemHeader" [innerHTML]="'ACCOUNT_CHANGEEMAIL_EMAIL_ADDRESS_SPAN' | translate"></span-->
                    <p class="formPagesInfoText ng-binding" [innerHTML]="'ACCOUNT_CHANGEEMAIL_EMAIL_DESCRIPTION' | translate"></p>
                    <input class="formInput" type="email"  [(ngModel)]="obChangeEmail.email" [placeholder]="'ACCOUNT_CHANGEEMAIL_EMAIL_PLACEHOLDER' | translate" required>
                    <a type="button" class="formButton" (click)='onValidate()' [innerHTML]="'ACCOUNT_CHANGEEMAIL_VALIDATE_BUTTON' | translate"></a>
                </div>
            </div>
        </div>
    </div>
    <div class="homeLoginArea" *ngIf="obChangeEmail.type==='email' && obChangeEmail.refNo != ''">
        <span class="homeSideBarHeader" [innerHTML]="'ACCOUNT_CHANGEEMAIL_EMAIL_TITLE' | translate"></span>
        <p class="formPagesInfoText ng-binding" [innerHTML]="'ACCOUNT_CHANGEEMAIL_EMAIL_OTP_DESCRIPTION' | translate"></p>
        <input class="formInput" type="password"  [(ngModel)]="obChangeEmail.otpCode" [placeholder]="'ACCOUNT_CHANGEEMAIL_OTP_CODE_PLACEHOLDER' | translate" required>
        <div class="homeProfileButtons">
            <a class="homeCardsFavouritesBtn" type="button" (click)="onConfirm()" [innerHTML]="'ACCOUNT_CHANGEEMAIL_CONFIRM_BUTTON' | translate"></a>
            <a class="homeProfileBtn" type="button" (click)="onValidate()" [innerHTML]="'ACCOUNT_CHANGE_EMAIL_AGAIN_VALIDATE_BUTTON' | translate"></a>
        </div>
    </div>
    <app-download-app></app-download-app>
</div>